<template>
  <h1>Edit role</h1>
  <form @submit.prevent="editRole">
    <div class="form-group mb-3">
      <label for="roleDescription" class="form-label">Description</label>
      <input type="text" id="roleDescription" class="form-control" v-model="localRole.description"
             ref="roleDescriptionInput" required>
    </div>
    <div class="form-group mb-3">
      <label for="roleMultiplier" class="form-label">Multiplier</label>
      <input type="number" id="roleMultiplier" class="form-control" v-model="localRole.multiplier" required>
    </div>
    <div v-if="nonFieldErrors.length" class="alert alert-danger mb-3">
      <ul class="mb-0">
        <li v-for="error in nonFieldErrors" :key="error">{{ error }}</li>
      </ul>
    </div>
    <div class="text-end">
      <button type="button" class="btn btn-secondary me-3" @click="cancel">Cancel</button>
      <button type="submit" class="btn btn-primary" @click="editDetails">Save</button>
    </div>

  </form>
</template>

<script>
import {getCSRFToken} from "@/store/auth";
import {API_BASE_URL} from "@/config";

export default {
  name: "EditOrganisationRole",
  props: {
    role: {
      type: Object,
      required: true
    }
  },
  emits: ['close'],
  data() {
    return {
      localRole: {...this.role},
      nonFieldErrors: []
    };
  },
  methods: {
    async editRole() {
      try {
        const response = await fetch(`${API_BASE_URL}/roles/${this.role.id}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': getCSRFToken()
          },
          body: JSON.stringify({
            description: this.localRole.description,
            multiplier: this.localRole.multiplier
          }),
          credentials: 'include'
        });

        if (response.ok) {
          this.$emit('close');
        } else {
          const errorData = await response.json();
          this.nonFieldErrors = errorData.non_field_errors || [];
          console.error('Error editing role', errorData);
        }
      } catch (error) {
        console.error('Error editing role', error);
      }
    },
    cancel() {
      this.$emit('close');
    },
    handleKeydown(event) {
      if (event.key === 'Escape') {
        this.cancel();
      }
    },
  },
  mounted() {
    this.$refs.roleDescriptionInput.focus();
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.handleKeydown);
  }
}
</script>

